import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Table, Button } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { RouterContext } from "../Onboarding";
import CustomTooltip from "utils/CustomTooltip";

export default function MicrosoftAdsAccess(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  const [idProvided, setIdProvided] = useState(false);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  const [accessGranted, setAccessGranted] = useState(
    props.teamAccess["Microsoft Ads"]["Restricted"] == "1" || props.teamAccess["Microsoft Ads"]["Full"] == "1"
  );
  let example = require("images/onboarding/microsoft-example.png");
  example = <img className="pt-3" src={`/datapulse${example}`} />;
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === true && (props.teamAccess["Microsoft Ads"]["Full"] == "1" || props.teamAccess["Microsoft Ads"]["Restricted"] == "1")) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  // useEffect(() => {
  //   if (props.microsoftAdsIds.length > 0) return null;
  //   let newRow = {};
  //   props.setMicrosoftAdsIds((rows) => [...rows, newRow]);
  // }, []);

  props.pageLocator();


  const authenticateFunction = (platform) => {
    window.open(platform["auth_url"], '_blank');
  };

  const deauthorizeFunction = (platform) => {
    window.open(platform["deauth_url"], '_blank');
  };

  const resetMessage = (platformName) => {
    return (`Resetting ${capitalize(platformName)} token will require you to authenticate again`)
  }

  const authButton = (platform) => {
    if (platform.authenticated) {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="danger" onClick={() => deauthorizeFunction(platform)}>
            Reset Token
            <CustomTooltip faClass=" far fa-question-circle f18 pl-2" message={resetMessage(platform["title"])} inline={true} />
          </Button>
        </>
      )
    } else {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="success" onClick={() => authenticateFunction(platform)}>
            Authenticate
            <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
          </Button>
        </>
      )
    }
  }

  return (
    <>
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant Microsoft Ads Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page you will grant access to Microsoft Ads. First, provide your account ID below. This will be used in DataPulse and will additionally
              give {route.organization.name} the means to request access to your account. Once access is requested, the client can log into their Microsoft Ads account
              and approve.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="mb-5  justify-content-center">
        <Col lg={5}>
          <Row >
            <Col md={5}>
              <p className="visby-bold pb-2 light-primary f14">Authenticate with Microsoft:</p>
            </Col>
          </Row>
          <Row className="pb-4">
            <Col>
              <div style={{ backgroundColor: "#E1E1E1", paddingRight: "10px", paddingTop: "20px", paddingLeft: "10px" }}>
                <div className="ml-3">
                  {authButton(props.api_platforms["microsoft_ads"])}
                  <p className="f-14 light-primary pb-3">{props.api_platforms["microsoft_ads"]["authenticated"] ?
                    "You have already authenticated with Microsoft Ads. If you need access to clients on a different account, reset your token and reauthenticate."
                    : "You must go through the authentication process before you can pull data from Microsoft Ads!"
                  }
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <p className="visby-bold pb-2 light-primary f14">Provide your account information below:</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={{ backgroundColor: "#E1E1E1", paddingRight: "10px", paddingBottom: "20px", paddingLeft: "10px" }}>
                <div className="table-responsive">
                  <Table className="overflow-hidden">
                    <thead>
                      <tr>
                        <td style={{ width: "145px" }} className="pl-3 f12 light-primary">
                          ID
                        </td>

                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Form.Control
                            name={`microsoft-ads-id`}
                            size="sm"
                            placeholder="ID"
                            style={{ width: "145px" }}
                            required
                            value={props.microsoftAdsIds[0] ? props.microsoftAdsIds[0].id : ""}
                            onChange={(e) => {
                              props.setMicrosoftAdsIds([{ "id": e.target.value }]);
                            }}
                            id={`ob-microsoft-ads-id`}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>

          {/* <Row className="my-4">
            <Col className="">
              <p className="f14 pb-2 mt-0 visby-bold light-primary">Email to grant access to:</p>
              <p className="f16 primary">support@digitalposition.com</p>
            </Col>
          </Row> */}
          <Row className="mb-4">
            <Col>
              <div className="px-3 py-2" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
                <div className="text-center">{example}</div>
                <div>
                  <p className="f12 p-3 light-primary">
                    Note: Microsoft Ads account IDs must now be taken from the URL. Select the account from the initial list of accounts, then check the url for
                    the "aid" parameter. The account id directly follows the = symbol.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={{ marginTop: "14px" }}>
                <p className="f14 primary">Complete as many of the below steps as possible, and check to confirm.</p>
              </div>
              <div className="grey-box" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
                <div className="pb-1">
                  <input hidden name="current_onboarding_page" defaultValue={window.location.href} readOnly />
                  <CustomFormCheck
                    required
                    className="primary"
                    id="ob-microsoft-ads-provided"
                    name="microsoft-ads-provided"
                    label="Account ID provided above, waiting for request."
                    checked={idProvided}
                    onChange={() => setIdProvided(!idProvided)}
                    dynamic
                  />
                </div>
                <div className="pb-1">
                  <CustomFormCheck
                    required
                    className="primary"
                    id="ob-microsoft-ads-requested"
                    name="microsoft-ads-requested"
                    label={`Access has been requested by ${route.organization.name}.`}
                    checked={props.teamAccess["Microsoft Ads"]["Requested"] == "1"}
                    dynamic
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Microsoft Ads"]["Requested"] = props.teamAccess["Microsoft Ads"]["Requested"] == "1" ? "0" : "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
                <div className="pb-1">
                  <CustomFormCheck
                    required
                    className="primary"
                    id="ob-microsoft-ads-approved"
                    name="microsoft-ads-approved"
                    label="Access has been approved by client."
                    dynamic
                    checked={accessGranted}
                    onChange={(e) => {
                      setAccessGranted(!accessGranted);
                      let accessChecked = props.teamAccess;
                      accessChecked["Microsoft Ads"]["Exist"] = "1";

                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
                <div>
                  <p className="pl-3 pb-1 f16 primary">Please indicate access granted</p>
                </div>

                <div className="pb-1 pl-3">
                  <CustomFormCheck
                    id="ob-microsoft-ads-admin"
                    name="microsoft-ads-admin"
                    label="Full"
                    disabled={!accessGranted}
                    checked={props.teamAccess["Microsoft Ads"]["Full"] == "1"}
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Microsoft Ads"]["Restricted"] = "0";
                      accessChecked["Microsoft Ads"]["Full"] = props.teamAccess["Microsoft Ads"]["Full"] == "1" ? "0" : "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
                <div className="pb-1 pl-3">
                  <CustomFormCheck
                    id="ob-microsoft-ads-standard"
                    name="microsoft-ads-standard"
                    label="Restricted"
                    disabled={!accessGranted}
                    checked={props.teamAccess["Microsoft Ads"]["Restricted"] == "1"}
                    onChange={(e) => {
                      let accessChecked = props.teamAccess;
                      accessChecked["Microsoft Ads"]["Full"] = "0";
                      accessChecked["Microsoft Ads"]["Restricted"] = props.teamAccess["Microsoft Ads"]["Restricted"] == "1" ? "0" : "1";
                      props.setTeamAccess({ ...accessChecked });
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        {/* <Col className="mt-3" lg={5}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/auSg3xUMAq8"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ maxWidth: "100%" }}></iframe>
        </Col> */}
      </Row>

      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
